import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
        iconText: {
            fontSize: '18px',
            fontWeight: 'bold',
        },
    }),
);

export default function Alerts(props) {
    const { severity, message, className, iconText, handleClose } = props;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Alert severity={severity} className={className} icon={iconText && <span className={classes.iconText}>{iconText}</span>} onClose={handleClose}>{message}</Alert>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Alerts/Alerts.js